import { LoadingState } from '../../types/loading-state';
import { createFetchedData } from '../../utils/fetched-data/create-fetched-data';
export const defaultSalesDataDomainState = {
    ticketPricesByShowtimeId: {},
    ticketTypesById: {},
    itemProfilesBySiteId: {},
    itemProfileForGiftShop: createFetchedData(LoadingState.NotLoaded),
    discountsById: {},
    sellableItemsForSiteByHopk: {},
    itemsById: {},
    itemModifierGroupsById: {},
    subscriptionBillingOptionsById: createFetchedData(LoadingState.NotLoaded)
};
